import { shallowEqual } from "react-redux";
import type {
    ColourType,
    ExtraType,
    PackAvailabilityType,
    PackType,
    PriceType,
    UpholsteryType,
    WheelType,
} from "../../../../../common-deprecated/types/CommonTypes";
import { useCarConfigSelector } from "../../redux/store";
import { selectCurrentAtmosphere } from "../../redux/slices/CarConfigAtmosphereSlice";
import useAphPack from "../useAphPack";
import type { AtmosphereType } from "../../utils/types/AtmosphereType";

type useAphLbxType = {
    actions: {
        selectPack: () => void;
        deselectPack: () => void;
        displayNotifications: () => void;
    };
    packContent: {
        selected: boolean;
        availability: PackAvailabilityType;
        price: PriceType;
        selectedEquipment: string[];
        optionalEquipment: ExtraType[];
        colours: ColourType[];
        upholsteries: (UpholsteryType | ExtraType)[];
        wheels: WheelType[];
        renderedEquipment: (UpholsteryType | ExtraType | WheelType)[];
        totalPackContent: number;
        includedPacks: PackType[];
        includedInPacks: PackType[];
        supportedWheeldrives?: AtmosphereType["wheeldrives"];
    };
};

const useAphLbxPack = (pack: PackType): useAphLbxType | null => {
    const packProps = useAphPack(pack);

    const currentAtmosphere = useCarConfigSelector(selectCurrentAtmosphere, shallowEqual);
    const allPacks = useCarConfigSelector((state) => state.items.packs);
    const basketPacks = useCarConfigSelector((state) => state.basket.packs);

    if (!packProps) return null;

    const { actions, packContent } = packProps;

    const supportedWheeldrives = currentAtmosphere?.wheeldrives.filter((wheeldrive) =>
        wheeldrive.packs.find((wheelDrivePack) => wheelDrivePack.id === pack.id),
    );

    const includedPacks = allPacks.filter((itemPack) => pack.includePacks.includes(itemPack.id));
    const includedInPacks = basketPacks.filter((basketPack) => basketPack.includePacks.includes(pack.id));

    return {
        actions,
        packContent: {
            ...packContent,
            includedPacks,
            includedInPacks,
            supportedWheeldrives,
        },
    };
};

export default useAphLbxPack;
